
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"22","viewBox":"0 0 33 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.24501 21C2.59091 21 1.25 19.8059 1.25 18.3328V3.66719C1.25 2.19414 2.59091 1 4.24501 1H21.0328C22.6868 1 24.0278 2.19414 24.0278 3.66719V18.3328C24.0278 19.8059 22.6868 21 21.0328 21H4.24501Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.7613 14.0715C24.3087 13.8559 24.0273 13.4429 24.0273 12.9941V9.00557C24.0273 8.5568 24.3087 8.14372 24.7613 7.9281L29.8584 5.50047C30.7999 5.05199 31.95 5.64442 31.95 6.5779V15.4218C31.95 16.3552 30.7999 16.9477 29.8584 16.4992L24.7613 14.0715Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.1342 11.8077C11.4932 11.8077 10.1631 10.445 10.1631 8.76418C10.1631 7.08331 11.4932 5.7207 13.1342 5.7207C14.775 5.7207 16.1051 7.08331 16.1051 8.76418C16.1051 10.445 14.775 11.8077 13.1342 11.8077Z","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.18262 17.0246C8.18262 14.5949 10.3743 12.6768 13.1505 12.6768C14.7578 12.6768 16.219 13.3162 17.0957 14.4671","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    